/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { AccordionDetails, Accordion, Container, Grid, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, Box, TableRow, CircularProgress } from '@mui/material'
import { analyzePerformance } from './utils.js'
import { AccordionSummaryInfo } from './accordionSummaryInfo.js'

const OverallStatistics = ({ data }) => {
  const winRate = parseFloat((data.winRate * 100).toFixed(0))
  const kdaString = `${(data.totalKills / data.totalGames).toFixed(1)} / ${(data.totalDeaths / data.totalGames).toFixed(1)} / ${(data.totalAssists / data.totalGames).toFixed(1)}`
  const kdaValue = parseFloat(data.overallKda.toFixed(2))

  return (
    <Grid item xs={12}>
      <Paper elevation={3} sx={{ padding: 1, display: 'flex', alignItems: 'center', backgroundColor: '#1e1e2e', color: '#ffffff' }}>
        <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', mr: 1 }}>
          <Box position="relative" display="inline-flex">
                  <CircularProgress variant="determinate" value={winRate} size={50} thickness={7} sx={{ color: '#00b0ff' }}/>
                  <CircularProgress variant="determinate" value={winRate - 100} size={50} thickness={7} sx={{ color: '#c4251f', position: 'absolute', left: 0 }}/>
          </Box>
        <Box sx={{ ml: 2, textAlign: 'center' }}>
        <Typography variant="body1" component="div" sx={{ color: '#FFFFFF', fontWeight: 600, fontSize: 14 }}>{`${winRate}% WR`}</Typography>
        <Typography variant="caption" component="div" sx={{ color: '#cddcfe', fontFamily: 'Roboto, sans-serif' }}>{`Last ${data.totalGames} games`}</Typography>
      </Box>
    </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <Typography variant="body1" component="div" sx={{ color: '#FFFFFF', fontWeight: 600, fontSize: 14 }}>{kdaValue} KDA</Typography>
          <Typography variant="caption" component="div" sx={{ color: '#cddcfe', fontFamily: 'Roboto, sans-serif' }}>{kdaString}</Typography>
        </Box>
      </Paper>
    </Grid>
  )
}

const GameParticipantTable = ({ title, participants }) => (
  <>
    <Typography variant="subtitle1" style={{ marginBottom: 16 }}>
      {title}
    </Typography>
    <TableContainer component={Paper} style={{ marginBottom: 16 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Summoner</TableCell>
            <TableCell>Champion</TableCell>
            <TableCell>Kills</TableCell>
            <TableCell>Deaths</TableCell>
            <TableCell>Assists</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {participants.map((participant) => (
            <TableRow key={participant.puuid}>
              <TableCell>{participant.summonerName}</TableCell>
              <TableCell>{participant.championName}</TableCell>
              <TableCell>{participant.stats.kills}</TableCell>
              <TableCell>{participant.stats.deaths}</TableCell>
              <TableCell>{participant.stats.assists}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
)

// TODO: Add P/Kill 82% and cs
const MatchHistory = ({ data }) => {
  const { games, searchedName } = data

  return (
    <Grid item xs={12}>
      {games.map((game, gameIndex) => {
        const participant = game.participants.find(p => p.puuid === searchedName)
        if (!participant) return null

        const winners = game.participants.filter(p => p.win)
        const losers = game.participants.filter(p => !p.win)

        return (
          <Accordion key={gameIndex} style={{ width: '100%', overflow: 'hidden', marginBottom: 10 }}>
            <AccordionSummaryInfo game={game} searchedName={searchedName} gameIndex={gameIndex}/>
            <AccordionDetails style={{ padding: 0, overflow: 'hidden' }}>
              <Paper elevation={3} style={{ padding: 16, width: '100%' }}>
                <GameParticipantTable title="Victory" participants={winners} />
                <GameParticipantTable title="Defeat" participants={losers} />
              </Paper>
            </AccordionDetails>
          </Accordion>
        )
      })}
    </Grid>
  )
}

const Dashboard = ({ data }) => {
  const [visibleGames, setVisibleGames] = useState(20)
  const [loading, setLoading] = useState(false)

  const handleShowMore = () => {
    setLoading(true)
    setTimeout(() => {
      setVisibleGames((prev) => prev + 20)
      setLoading(false)
    }, 100)
  }

  const dataShown = { games: data.games?.slice(0, visibleGames), searchedName: data.searchedName }

  return (
    <Container>
      <Grid container spacing={3}>
        <OverallStatistics data={analyzePerformance(dataShown)} />
        <MatchHistory data={dataShown} />
      </Grid>
      {visibleGames < data.games.length && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <div style={{
            display: 'block',
            width: '100%',
            padding: '10px',
            backgroundColor: '#2e2e2e',
            color: 'white',
            border: '1px solid #444',
            borderRadius: '5px',
            textAlign: 'center',
            marginTop: '20px',
            cursor: 'pointer'
          }} onClick={handleShowMore} disabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Show More'}
          </div>
        </div>

      )}
    </Container>
  )
}

export const MatchInfo = ({ data }) => {
  return (
    <>
      {Object.keys(data).length > 0 && (
        <div style={{ width: '90%', height: 'auto', margin: 'auto' }}>
          <Dashboard data={data}/>
        </div>
      )}
    </>
  )
}
